// PrimaryButton.jsx
import React from "react";
import "../../../css/components/buttons/PrimaryButton.css";

const PrimaryButton = ({ children, text, ...props }) => (
    <button className="primary-btn" {...props}>
        <div className="nav-regular">

    {text || children}
        </div>
  </button>
);

export default PrimaryButton;
